import navigationJson from '@/data/navigation.json';

export default {
  namespaced: true,

  state: {
    isOpen: false,
    isLinkOpen: false,
    items: navigationJson,
  },

  getters: {
    //
  },

  mutations: {
    toggleMenu(state) {
      state.isOpen = !state.isOpen;
    },
    toggleLinkMenu(state) {
      state.isLinkOpen = !state.isLinkOpen;
      console.log(state.isLinkOpen);
    },

    closeMenu(state) {
      state.isOpen = false;
      state.isLinkOpen = false;
    },

    openMenu(state) {
      state.isOpen = true;
    },
  },

  actions: {
    toggleMenu({ commit }) {
      commit('toggleMenu');
    },

    toggleLinkMenu({commit}) {
      commit('toggleLinkMenu');
    },

    openMenu({ commit, state }) {
      if (!state.isOpen) {
        commit('openMenu');
      }
    },

    closeMenu({ commit, state }) {
      if (state.isOpen) {
        commit('closeMenu');
      }
    },
  },
};
